<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="500"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <!--
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
      -->
        <el-form-item label="适用身份" prop="roleList">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="form.roleList" @change="handleCheckedChange">
            <el-checkbox :label="item.value" v-for="item in roleOptions" :key="item">{{ item.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
          <br>提示：单选和排序类问题，若问题以?号结尾，则最后一个选项客人可以自定义编辑回复内容
        </el-form-item>
        <el-form-item label="类型" prop="typehood">
          <el-select v-model="form.typehood" placeholder="请选择问题类型">
            <el-option
              v-for="item in typehoods"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="[1,2,3,4].indexOf(form.typehood) > -1" label="选项描述" prop="">
          <el-tag
            size="medium"
            :key="tag"
            v-for="tag in form.optionList"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新增选项描述</el-button>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model.trim="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注，选填"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import typehoods from './typehood.config'
import { createQuest, updateQuest, } from '@/api/alfmeier'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'AlfmeierQuestEdit',
  emits: ['fetch-data'],
  data() {
    return {
      typehoods,
      title: '',
      branchList: [],
      roleOptions: [
        {
          label: '租车公司',
          value: '租车公司',
        },{
          label: '司机',
          value: '司机',
        },{
          label: '企业用户',
          value: '企业用户',
        },{
          label: '乘客',
          value: '乘客',
        },{
          label: '媒体公司',
          value: '媒体公司',
        },
      ],
      form: {
        questId: '',
        branchId: '',
        typehood: '',
        roleList: [],
        optionList: [],
        title: '',
        text: '',
        order: 1,
      },
      checkAll: false,
      isIndeterminate: true,
      inputVisible: false,
      inputValue: '',
      rules: {
        roleList: [{ required: true, trigger: 'blur', message: '请选择适用身份' }],
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        typehood: [{ required: true, trigger: 'blur', message: '请选择类型' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    handleCheckAllChange(val) {
      this.form.roleList = val ? this.roleOptions.map(e => e.value) : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.roleOptions.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.roleOptions.length
    },
    handleClose(tag) {
      this.form.optionList.splice(this.form.optionList.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.form.optionList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改问卷'
        this.form.title = row.title
        this.form.typehood = row.typehood
        this.form.roleList = row.basic.roleList
        this.form.optionList = row.basic.optionList
        this.form.text = row.basic.text
        this.form.order = row.basic.order
        this.form.branchId = row.extra.branchId
        this.form.questId = row.questId
        this.handleCheckedChange(row.basic.roleList)
      } else {
        this.title = '新增问卷'
        this.handleCheckedChange([])
      }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const questId = this.form.questId
          const data = Object.assign({}, this.form)
          if(data.typehood == 3 && data.optionList.length != 5){
            return this.$message.warning('星级描述数量不正确')
          }
          this.$baseConfirm(
            `你确定要${questId ? '修改' : '新增'}问卷吗`,
            null,
            async () => {
              questId ? await updateQuest(data) : await createQuest(data)
              this.$baseMessage(
                `${questId ? '修改' : '新增'}问卷成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  max-width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.error-color {
  color: #f56c6c;
}
.h2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
